import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";
import {
  Mail,
  Globe,
  Building2,
  MapPin,
  Clock
} from "lucide-react";
import { submitContact } from "../auth/service/contactApi";
import { toast } from "react-toastify";
import Footer from "./Footer";

function ContactPage() {
  const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
});

const handleChange = (e:any) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = async (e:any) => {
  e.preventDefault();

  if (
    !formData.name ||
    !formData.email ||
    !formData.subject ||
    !formData.message
  ) {
    toast.error("Please fill all required fields.");
    return;
  }

  try {
    setLoading(true);

    await submitContact(formData);

    toast.success("Your message has been sent successfully.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  } catch (error) {
    toast.error("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      {/* Hero */}
      <section
        className="py-2"

      >
        <Container>

        <h1 className="display-4 fw-bold text-center mb-3">
  Get in Touch
</h1>

<p
  className="text-center text-muted mx-auto"
  style={{ maxWidth: 650 }}
>
  Have questions about PriceWorth, group buying, payments, or partnerships?
  We'd love to hear from you. Fill out the form below and our team will respond
  within one business day.
</p>


        </Container>
      </section>

      <section
        className="py-5"
        style={{ background: "#f8fafc" }}
      >
        <Container>
          <Row className="g-4">

            {/* Form */}
            <Col lg={7}>
              <Card
                className="border-0 shadow-lg"
                style={{ borderRadius: 18 }}
              >
                <CardBody className="p-4 p-lg-5">

                  <h3 className="fw-bold mb-2">
                    Send us a Message
                  </h3>

                  <p className="text-muted mb-4">
                    Fill out the form and we'll get back to you
                    within 24 business hours.
                  </p>

    <Form onSubmit={handleSubmit}>
  <Row>
    <Col md={6}>
      <FormGroup floating className="mb-3">
        <Input
          id="name"
          name="name"
          type="text"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <Label for="name">Full Name *</Label>
      </FormGroup>
    </Col>

    <Col md={6}>
      <FormGroup floating className="mb-3">
        <Input
          id="email"
          name="email"
          type="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <Label for="email">Email Address *</Label>
      </FormGroup>
    </Col>
  </Row>

  <Row>
    <Col md={6}>
      <FormGroup floating className="mb-3">
        <Input
          id="phone"
          name="phone"
          type="tel"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          maxLength={15}
        />
        <Label for="phone">Phone Number*</Label>
      </FormGroup>
    </Col>

    <Col md={6}>
      <FormGroup floating className="mb-3">
        <Input
          id="subject"
          name="subject"
          type="text"
          placeholder="Subject"
          value={formData.subject}
          onChange={handleChange}
          required
        />
        <Label for="subject">Subject *</Label>
      </FormGroup>
    </Col>
  </Row>

  <FormGroup floating className="mb-4">
    <Input
      id="message"
      name="message"
      type="textarea"
      placeholder="Message"
      style={{ height: "160px" }}
      value={formData.message}
      onChange={handleChange}
      required
    />
    <Label for="message">Message *</Label>
  </FormGroup>

  <Button
    color="primary"
    size="lg"
    className="rounded-pill px-5"
    disabled={loading}
  >
    {loading ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        />
        Sending...
      </>
    ) : (
      "Send Message"
    )}
  </Button>
</Form>

                </CardBody>
              </Card>
            </Col>

            {/* Right Side */}
            <Col lg={5}>

              {/* Contact */}
              <Card
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: 18 }}
              >
                <CardBody className="p-4">

                  <h4 className="fw-bold mb-4">
                    Contact Information
                  </h4>

                  <div className="d-flex mb-4">
                    <Mail
                      size={22}
                      className="text-primary me-3 mt-1"
                    />

                    <div>
                      <h6 className="mb-1">
                        Email
                      </h6>

                      <a
                        href="mailto:support@priceworth.com"
                        className="text-decoration-none"
                      >
                        support@priceworth.com
                      </a>
                      <br />
                      <a
                        href="mailto:contact@priceworth.com"
                        className="text-decoration-none"
                      >
                        contact@priceworth.com
                      </a>
                    </div>
                  </div>

                  {/* <div className="d-flex mb-4">
                    <Globe
                      size={22}
                      className="text-primary me-3 mt-1"
                    />

                    <div>
                      <h6 className="mb-1">
                        Website
                      </h6>

                      <a
                        href="https://priceworth.com"
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none"
                      >
                        www.priceworth.com
                      </a>
                      <br />
                      <a
                        href="https://wocons.com"
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none"
                      >
                        www.wocons.com
                      </a>
                    </div>
                  </div> */}

                  <div className="d-flex">
                    <MapPin
                      size={22}
                      className="text-primary me-3 mt-1"
                    />

                    <div>
                      <h6 className="mb-1">
                        Office
                      </h6>

                      <p className="text-muted mb-0">
                        Bangalore,
                        Karnataka,
                        India
                      </p>
                    </div>
                  </div>

                </CardBody>
              </Card>

              {/* Company */}
              <Card
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: 18 }}
              >
                <CardBody className="p-4">

                  <div className="d-flex align-items-center mb-3">
                    <Building2
                      className="text-primary me-2"
                    />
                    <h5 className="fw-bold mb-0">
                      Company Details
                    </h5>
                  </div>

                  <table className="table table-borderless mb-0">
                    <tbody>

                      <tr>
                        <td className="fw-semibold">
                          Business
                        </td>
                        <td>
                          Wocons Private Limited
                        </td>
                      </tr>

                      <tr>
                        <td className="fw-semibold">
                          Brand
                        </td>
                        <td>PriceWorth</td>
                      </tr>

                      <tr>
                        <td className="fw-semibold">
                          CIN
                        </td>
                        <td><code>[U72900KA2022PTC163725]</code> </td>
                      </tr>

                      <tr>
                        <td className="fw-semibold">
                          GSTIN
                        </td>
                        <td><code>[29AADCW3156F1Z8]</code></td>
                      </tr>
                      <tr>
                        <td className="fw-semibold">
                          Business Hours
                        </td>
                        <td>  10 AM to 10 PM </td>
                      </tr>

                    </tbody>
                  </table>

                </CardBody>
              </Card>
 
             
            </Col>

          </Row>
        </Container>
      </section>
    
<Footer/>

    </>
  );
}

export default ContactPage;